import React from "react";
const LastDigit = ({
  eventDetails,
  figuredata,
  setBetSlipDetails,
  getBetPlaceFigureList,
  LoginUserId
}) => {
  //console.log("getBetPlaceFigureList->", getBetPlaceFigureList);
  let title = "";
  let odds = 0;
  let lastdigitid = 0;
  let lastdigitidStr = "";

  if (figuredata !== null && figuredata !== undefined) {
    title = figuredata.title;
    odds = figuredata.odd;
    lastdigitid = figuredata.lastdigitid;
    lastdigitidStr = figuredata.lastdigitid.$oid;
  }

  const showBetSlip = (betType, teamName, sid, rate) => {
    setBetSlipDetails({
      bet_type: betType,
      runnername: teamName,
      sid: sid,
      odds: rate,
      amount: 0,
      lastdigitid: lastdigitid,
      market_type: "digit"
    });
  };

  if (getBetPlaceFigureList !== null && getBetPlaceFigureList.length > 0) {
    //console.log("getBetPlaceFigureList->", getBetPlaceFigureList);
  }

  const getFigureBook = (number, figureId) => {
    let returnArr = "";
    if (getBetPlaceFigureList !== null && getBetPlaceFigureList.length > 0) {
      for (let i = 0; i < getBetPlaceFigureList.length; i++) {
        let obj = getBetPlaceFigureList[i];
        let key = obj.key;
        let userKey = figureId + "_" + LoginUserId;
        if (key !== undefined && key !== null && key === userKey) {
          let values = obj.value;

          if (
            values !== null &&
            values !== undefined &&
            values[0]?.user_id == LoginUserId
          ) {
            let record = values[0];
            let amt = 0;
            if (number === 0) {
              amt = record.num_0;
            } else if (number === 1) {
              amt = record.num_1;
            } else if (number === 2) {
              amt = record.num_2;
            } else if (number === 3) {
              amt = record.num_3;
            } else if (number === 4) {
              amt = record.num_4;
            } else if (number === 5) {
              amt = record.num_5;
            } else if (number === 6) {
              amt = record.num_6;
            } else if (number === 7) {
              amt = record.num_7;
            } else if (number === 8) {
              amt = record.num_8;
            } else if (number === 9) {
              amt = record.num_9;
            }
            returnArr =
              amt > 0 ? (
                <span
                  style={{
                    color: "green",
                    fontWeight: "bold",
                    paddingLeft: "0px",
                    fontSize: "15px"
                  }}
                >
                  {amt}
                </span>
              ) : (
                <span
                  style={{
                    color: "red",
                    fontWeight: "bold",
                    paddingLeft: "0px",
                    fontSize: "15px"
                  }}
                >
                  {amt}
                </span>
              );
          }
        }
      }
    }
    return returnArr;
  };
  return (
    <div style={{ display: figuredata == null ? "none" : "" }}>
      <div className="tb-content">
        <div className="market-titlebar">
          <p className="market-name">
            <span className="market-name-badge">
              <i className="market-name-icon">
                <img
                  src="/assets/images/time-img.png"
                  style={{
                    filter: "invert(100%)",
                    marginTop: "-8px",
                    marginLeft: "-1px"
                  }}
                />
              </i>
              <span id="fig_title"></span>
              <span style={{ textTransform: "initial" }}>
                {title} (MaxBet: 200K){" "}
              </span>
            </span>
            <span className="rules-badge">
              <i className="fa fa-info-circle"></i>
            </span>
          </p>
        </div>
        <div>
          <div className="card" style={{ padding: "1px 18px" }}>
            <div className="row">
              <div className="col-3 col-lg-4 mobilehide"></div>

              <a onClick={() => showBetSlip("b", "0 Digit", 0, odds)}>
                <div
                  className="col customcheck"
                  style={{
                    textAlign: "center",
                    border: "1px solid black",
                    width: "59px"
                  }}
                >
                  <div id="10">
                    <b>
                      <span className="priceodd ">0</span>
                      <br />
                    </b>
                    <span className="priceamount fig_odd">{odds}</span>
                    <br />
                    <hr style={{ margin: "0px" }} />
                    <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                      <span className="positioncustom" style={{ color: "red" }}>
                        <strong>
                          <span>{getFigureBook(0, lastdigitidStr)}</span>
                        </strong>
                      </span>
                    </div>
                  </div>
                </div>
              </a>

              <a onClick={() => showBetSlip("b", "1 Digit", 1, odds)}>
                <div
                  className="col customcheck"
                  style={{
                    textAlign: "center",
                    border: "1px solid black",
                    width: "59px"
                  }}
                >
                  <div id="1">
                    <b>
                      <span className="priceodd">1</span>
                      <br />
                    </b>
                    <span className="priceamount fig_odd">{odds}</span>
                    <br />
                    <hr style={{ margin: "0px" }} />
                    <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                      <span className="positioncustom" style={{ color: "red" }}>
                        <strong>
                          <span>{getFigureBook(1, lastdigitidStr)}</span>
                        </strong>
                      </span>
                    </div>
                  </div>
                </div>
              </a>

              <a onClick={() => showBetSlip("b", "2 Digit", 2, odds)}>
                <div
                  className="col customcheck"
                  style={{
                    textAlign: "center",
                    border: "1px solid black",
                    width: "59px"
                  }}
                >
                  <div id="2">
                    <b>
                      <span className="priceodd">2</span>
                      <br />
                    </b>
                    <span className="priceamount fig_odd">{odds}</span>
                    <br />
                    <hr style={{ margin: "0px" }} />
                    <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                      <span className="positioncustom" style={{ color: "red" }}>
                        <strong>
                          <span>{getFigureBook(2, lastdigitidStr)}</span>
                        </strong>
                      </span>
                    </div>
                  </div>
                </div>
              </a>

              <a onClick={() => showBetSlip("b", "3 Digit", 3, odds)}>
                <div
                  className="col customcheck"
                  style={{
                    textAlign: "center",
                    border: "1px solid black",
                    width: "59px"
                  }}
                >
                  <div id="3">
                    <b>
                      <span className="priceodd">3</span>
                      <br />
                    </b>
                    <span className="priceamount fig_odd">{odds}</span>
                    <br />
                    <hr style={{ margin: "0px" }} />
                    <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                      <span className="positioncustom" style={{ color: "red" }}>
                        <strong>
                          <span>{getFigureBook(3, lastdigitidStr)}</span>
                        </strong>
                      </span>
                    </div>
                  </div>
                </div>
              </a>

              <a onClick={() => showBetSlip("b", "4 Digit", 4, odds)}>
                <div
                  className="col customcheck"
                  style={{
                    textAlign: "center",
                    border: "1px solid black",
                    width: "59px"
                  }}
                >
                  <div id="4">
                    <b>
                      <span className="priceodd">4</span>
                      <br />
                    </b>
                    <span className="priceamount fig_odd">{odds}</span>
                    <br />
                    <hr style={{ margin: "0px" }} />
                    <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                      <span className="positioncustom" style={{ color: "red" }}>
                        <strong>
                          <span>{getFigureBook(4, lastdigitidStr)}</span>
                        </strong>
                      </span>
                    </div>
                  </div>
                </div>
              </a>

              <div className="col-3 col-lg-4 mobilehide"></div>
            </div>
            <div className="row">
              <div className="col-3 col-lg-4 mobilehide"></div>

              <a onClick={() => showBetSlip("b", "5 Digit", 5, odds)}>
                <div
                  className="col customcheck"
                  style={{
                    textAlign: "center",
                    border: "1px solid black",
                    width: "59px"
                  }}
                >
                  <div id="5">
                    <b>
                      <span className="priceodd">5</span>
                      <br />
                    </b>
                    <span className="priceamount fig_odd">{odds}</span>
                    <br />
                    <hr style={{ margin: "0px" }} />
                    <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                      <span className="positioncustom" style={{ color: "red" }}>
                        <strong>
                          {" "}
                          <span>{getFigureBook(5, lastdigitidStr)}</span>
                        </strong>
                      </span>
                    </div>
                  </div>
                </div>
              </a>

              <a onClick={() => showBetSlip("b", "6 Digit", 6, odds)}>
                <div
                  className="col customcheck"
                  style={{
                    textAlign: "center",
                    border: "1px solid black",
                    width: "59px"
                  }}
                >
                  <div id="6">
                    <b>
                      <span className="priceodd">6</span>
                      <br />
                    </b>
                    <span className="priceamount fig_odd">{odds}</span>
                    <br />
                    <hr style={{ margin: "0px" }} />
                    <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                      <span className="positioncustom" style={{ color: "red" }}>
                        <strong>
                          {" "}
                          <span>{getFigureBook(6, lastdigitidStr)}</span>
                        </strong>
                      </span>
                    </div>
                  </div>
                </div>
              </a>

              <a onClick={() => showBetSlip("b", "7 Digit", 7, odds)}>
                <div
                  className="col customcheck"
                  style={{
                    textAlign: "center",
                    border: "1px solid black",
                    width: "59px"
                  }}
                >
                  <div id="7">
                    <b>
                      <span className="priceodd">7</span>
                      <br />
                    </b>
                    <span className="priceamount fig_odd">{odds}</span>
                    <br />
                    <hr style={{ margin: "0px" }} />
                    <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                      <span className="positioncustom" style={{ color: "red" }}>
                        <strong>
                          {" "}
                          <span>{getFigureBook(7, lastdigitidStr)}</span>
                        </strong>
                      </span>
                    </div>
                  </div>
                </div>
              </a>

              <a onClick={() => showBetSlip("b", "8 Digit", 8, odds)}>
                <div
                  className="col customcheck"
                  style={{
                    textAlign: "center",
                    border: "1px solid black",
                    width: "59px"
                  }}
                >
                  <div id="8">
                    <b>
                      <span className="priceodd">8</span>
                      <br />
                    </b>
                    <span className="priceamount fig_odd">{odds}</span>
                    <br />
                    <hr style={{ margin: "0px" }} />
                    <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                      <span className="positioncustom" style={{ color: "red" }}>
                        <strong>
                          {" "}
                          <span>{getFigureBook(8, lastdigitidStr)}</span>
                        </strong>
                      </span>
                    </div>
                  </div>
                </div>
              </a>

              <a onClick={() => showBetSlip("b", "9 Digit", 9, odds)}>
                <div
                  className="col customcheck"
                  style={{
                    textAlign: "center",
                    border: "1px solid black",
                    width: "59px"
                  }}
                >
                  <div id="9">
                    <b>
                      <span className="priceodd">9</span>
                      <br />
                    </b>
                    <span className="priceamount fig_odd">{odds}</span>
                    <br />
                    <hr style={{ margin: "0px" }} />
                    <div style={{ backgroundColor: "rgb(233, 246, 252)" }}>
                      <span className="positioncustom" style={{ color: "red" }}>
                        <strong>
                          {" "}
                          <span>{getFigureBook(9, lastdigitidStr)}</span>
                        </strong>
                      </span>
                    </div>
                  </div>
                </div>
              </a>

              <div className="col-3 col-lg-4 mobilehide"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default LastDigit;